import React, { useEffect, useRef, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";

import { FiltroRotacionCXC } from "./FiltroRotacionCXC";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useBoxProyecciones } from "../ProyeccionesVentas/useBoxProyecciones";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { FiltroRotacionCXC2 } from "./FiltroRotacionCXC2";

const SESSION_KEY = "rotacion_cxc_filtro";

export const RotacionCXCMainScreen = () => {
  const history = useHistory();
  const helpRef = useRef(null);
  const location = useLocation();
  const sucursales = location.state?.sucursales;
  const sucursalesSeleccionadas = location.state?.sucursalesSeleccionadas || 0;
  const ejercicioSelect = location.state?.ejercicioSelect || 0;
  const periodoSelect = location.state?.periodoSelect || 0;
  const optima = location.state?.optima || false;

  const [boxstate, setBoxState, updateBoxState] = useBoxProyecciones();
  const [inventario, setInventario] = useState();
  const [editarGuia, setEditarGuia] = useState(false);
  const [totales, setTotales] = useState();
  const [rotacion, setRotacion] = useState();
  const [openHelp, setOpenHelp] = useState(false);
  const [titulo, setTitulo] = useState(optima ? "ROTACION CUENTAS POR COBRAR OPTIMA" : "ROTACION CUENTAS POR COBRAR");

  const savedSession = (() => {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  })();

  const [filtroInicial] = useState(() => savedSession?.filtro || null);
  const [ejercicioInicial] = useState(() => savedSession?.ejercicio || 0);
  const [periodoInicial] = useState(() => savedSession?.periodo || 0);
  const [sucursalesSeleccionadasArray, setSucursalesSeleccionadasArray] =
    useState(location.state?.sucursalesSeleccionadasArray || []);

  const saveSession = (ejercicio, periodo, filtro) => {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify({ ejercicio, periodo, filtro: filtro || null }));
  };

  useEffect(() => {
    if (ejercicioSelect !== 0) {
      updateBoxState((prev) => ({ ...prev, ejercicioinicio: ejercicioSelect }));
    }
    if (periodoSelect !== 0) {
      updateBoxState((prev) => ({ ...prev, periodofin: periodoSelect }));
    }
  }, []);

  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  // useEffect(() => {
  //     const today = new Date();
  //     let currentMonth = today.getMonth() + 1;
  //     let currentYear = today.getFullYear();

  //     // console.log(boxstate)
  //     const ejercicio = ejercicioSelect === 0 ? currentYear : ejercicioSelect
  //     const mes = periodoSelect === 0 ? currentMonth : periodoSelect

  //     if (periodoSelect !== 0 || ejercicioSelect !== 0) {
  //         onIniciar(ejercicio, mes);

  //     }

  // }, []);

  const onIniciar = (ejercicio, periodo, filtroSeleccionado) => {
    setLoader({ ...loader, mostrar: true });
    updateBoxState((prev) => ({
      ...prev,
      ejercicioinicio: ejercicio,
      periodofin: periodo,
      filtro: filtroSeleccionado ? [filtroSeleccionado] : [],
    }));
    saveSession(ejercicio, periodo, filtroSeleccionado);
    const idFiltro = filtroSeleccionado?.id || 0;
    const tipoUbi = filtroSeleccionado?.tipo_ubi || "";

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `RotacionCXC/ReporteCXC?ejercicio=${ejercicio}&periodo=${periodo}&tipoUbi=${tipoUbi}&id=${idFiltro}&tipoReporte=D`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });

          const filasBody = result.rotacion.filter(
            (item) =>
              item.departamento !== "TOTALES" &&
              item.departamento !== "ROTACION TOTAL",
          );

          const totales = result.rotacion.find(
            (item) => item.departamento === "TOTALES",
          );
          const rotacionTotal = result.rotacion.find(
            (item) => item.departamento === "ROTACION TOTAL",
          );

          setInventario(filasBody);
          setTotales(totales);
          setRotacion(rotacionTotal);
          setEditarGuia(result.editor_guia);

          const mesFinalIndex = periodo - 1;
          const mesFinal = meses[mesFinalIndex];
          const anioFinal = ejercicio;

          let fechaFinal = new Date(ejercicio, mesFinalIndex, 1);

          let fechaInicio = new Date(fechaFinal);
          fechaInicio.setMonth(fechaInicio.getMonth() - 11);

          const mesInicio = meses[fechaInicio.getMonth()];
          const anioInicio = fechaInicio.getFullYear();

          const tituloBase = optima ? "ROTACION CUENTAS POR COBRAR OPTIMA" : "ROTACION CUENTAS POR COBRAR";
          const tituloP = `${tituloBase} ${mesInicio} ${anioInicio} - ${mesFinal} ${anioFinal}`;

          setTitulo(tituloP);

          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const onExecute = (ejercicio, periodo) => {
    setLoader({ ...loader, mostrar: true });

    const filtroSeleccionado = boxstate.filtro?.[0];
    saveSession(ejercicio, periodo, filtroSeleccionado);

    const idFiltro = filtroSeleccionado?.id || 0;
    const tipoUbi = filtroSeleccionado?.tipo_ubi || "";
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `RotacionCXC/ReporteCXC?ejercicio=${ejercicio}&periodo=${periodo}&tipoUbi=${tipoUbi}&id=${idFiltro}&tipoReporte=D`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });

          const filasBody = result.rotacion.filter(
            (item) =>
              item.departamento !== "TOTALES" &&
              item.departamento !== "ROTACION TOTAL",
          );

          setSucursalesSeleccionadasArray(boxstate.pv.sucursal || []);

          const totales = result.rotacion.find(
            (item) => item.departamento === "TOTALES",
          );
          const rotacionTotal = result.rotacion.find(
            (item) => item.departamento === "ROTACION TOTAL",
          );

          setInventario(filasBody);
          setTotales(totales);
          setRotacion(rotacionTotal);
          setEditarGuia(result.editor_guia);

          const mesFinalIndex = periodo - 1;
          const mesFinal = meses[mesFinalIndex];
          const anioFinal = ejercicio;

          let fechaFinal = new Date(ejercicio, mesFinalIndex, 1);

          let fechaInicio = new Date(fechaFinal);
          fechaInicio.setMonth(fechaInicio.getMonth() - 11);

          const mesInicio = meses[fechaInicio.getMonth()];
          const anioInicio = fechaInicio.getFullYear();

          const tituloBase = optima ? "ROTACION CUENTAS POR COBRAR OPTIMA" : "ROTACION CUENTAS POR COBRAR";
          const tituloP = `${tituloBase} ${mesInicio} ${anioInicio} - ${mesFinal} ${anioFinal}`;

          setTitulo(tituloP);

          resolve(result); // 🔥 IMPORTANTE
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const onRegresar = () => {
    sessionStorage.removeItem(SESSION_KEY);
    history.push("/Finanzas/Main");
  };

  const onAddGuia = () => {
    // console.log(boxstate)
    history.push("/Finanzas/GuiaCXC", {
      ejercicioSelect: boxstate.ejercicioinicio,
    });
  };

  const regionMap = {
    1: [1, 11, 21, 31, 41, 51, 61],
    2: [2, 12, 22, 32, 42, 52],
  };

  const onDetalle = (tipoReporte, iddepartamento, departamento) => {
    const filtro = boxstate.filtro?.[0];

    let sucursalesDetalle = [];

    if (filtro?.tipo_ubi === "R") {
      sucursalesDetalle = regionMap[filtro.id] || [];
    }

    if (filtro?.tipo_ubi === "S") {
      sucursalesDetalle = [filtro.id];
    }

    history.push("/Finanzas/DetalleCXC", {
      periodoSelect: boxstate.periodofin,
      ejercicioSelect: boxstate.ejercicioinicio,
      sucursales: sucursales,
      sucursalesSeleccionadas: sucursalesDetalle,
      tipoReporte,
      optima: optima,
      departamento: [
        {
          iddepartamento,
          departamento,
        },
      ],
    });
  };

  const onGeneraExcel = () => {
    const filtroSeleccionado = boxstate.filtro?.[0];

    const idFiltro = filtroSeleccionado?.id || 0;
    const tipoUbi = filtroSeleccionado?.tipo_ubi || "";

    const endpoint = optima
      ? `RotacionCXC/ImprimirExcelReporteOptimo?ejercicio=${boxstate.ejercicioinicio}&periodo=${boxstate.periodofin}&tipoUbi=${tipoUbi}&id=${idFiltro}&tipoReporte=D&titulo=${titulo}`
      : `RotacionCXC/ImprimirExcelReporte?ejercicio=${boxstate.ejercicioinicio}&periodo=${boxstate.periodofin}&tipoUbi=${tipoUbi}&id=${idFiltro}&tipoReporte=D&titulo=${titulo}`;

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(endpoint)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        // Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  return (
    <PlantillaScreen
      titulo={titulo}
      className={"rotacion-cxc-main-screen"}
      className_main={2}
    >
      <LoaderScreen loader={loader} />

      <div className="rotacion-cxc-actions">
        <div className="rotacion-cxc-botones-container">
          <div
            className="reporte-recuperacion-responsable-actions-regresar"
            onClick={() => onRegresar()}
          >
            <ArrowBackIcon /> Regresar
          </div>
          <div className="reporte-recuperacion-responsable-actions-filtro">
            <FiltroRotacionCXC2
              onBoxChange={setBoxState}
              boxState={boxstate}
              BoxClick={onExecute}
              OnIniciar={onIniciar}
              updateBoxState={updateBoxState}
              titulo_filtro={"FILTRO ROTACION CXC"}
              extrayear={3}
              sucursales={sucursales}
              filtroInicial={filtroInicial}
              ejercicioPersistente={ejercicioInicial}
              periodoPersistente={periodoInicial}
            />
          </div>
        </div>
        <div className="buttons-cxc">
          {editarGuia === true && (
            <button className="agregar" onClick={() => onAddGuia()}>
              <AddCircleIcon />
              <i className=" icon-file-excel" /> Guia
            </button>
          )}
          <button className="excel" onClick={() => onGeneraExcel()}>
            {/* <AddCircleIcon /> */}
            <i className=" icon-file-excel" /> Excel
          </button>

          <div style={{ position: "relative" }} ref={helpRef}>
            <button className="ayuda" onClick={() => setOpenHelp(!openHelp)}>
              <HelpOutlineIcon />
              Ayuda
            </button>

            {openHelp && (
              <div className="popover-help-cxc">
                <div className="arrow"></div>

                <div className="popover-titulo">
                  <div className="popover-header">
                    <div className="popover-header-titulo">
                      {"Métricas de gestión de cartera"}
                    </div>
                  </div>
                  <div className="plantilla-screen-efecto">
                    <div className="plantilla-screen-efecto-bl"></div>
                    <div className="plantilla-screen-efecto-circle"></div>
                    <div className="plantilla-screen-efecto-br"></div>
                  </div>
                </div>

                <div class="container-cxc">
                  {/* <!-- HEADER --> */}
                  {/* <div class="header">
                                        <h2>Métricas de gestión de cartera</h2>
                                        <p>Rotación de cartera y período promedio de cobranza</p>
                                    </div> */}

                  {/* <!-- MAIN CONTENT --> */}
                  <div class="main-content-cxc">
                    {/* <!-- FÓRMULA 1 --> */}
                    <div class="formula-section">
                      <div class="formula-title">Rotación de cartera</div>
                      <div class="formula">
                        <div class="numerador">Facturación de Crédito</div>
                        <div class="linea-division"></div>
                        <div class="denominador">
                          <div>
                            <span class="simbolo">(</span>
                            Cartera Inicial + Cartera Final
                            <span class="simbolo">)</span>
                          </div>
                          <div class="denominador-pequeno">÷ 2</div>
                        </div>
                      </div>

                      <div class="info-box">
                        <p>
                          <strong>Resultado:</strong> Número de veces que se
                          recuperó la cartera.
                        </p>
                        <p>
                          <strong>Ejemplo:</strong> Si el resultado es 12,
                          significa que la cartera se cobró 12 veces en el año.
                        </p>
                      </div>
                    </div>

                    {/* <!-- FÓRMULA 2 --> */}
                    <div class="formula-section">
                      <div class="formula-title highlight">
                        Período promedio de cobranza (DPP)
                      </div>
                      <div class="formula">
                        <div class="numerador">365 días</div>
                        <div class="linea-division"></div>
                        <div class="denominador">
                          Rotación de
                          <br />
                          Cuentas por Cobrar
                        </div>
                      </div>

                      <div class="info-box highlight">
                        <p>
                          <strong>Resultado:</strong> Días promedio para cobrar
                          a clientes.
                        </p>
                        <p>
                          <strong>Ejemplo:</strong> 365 ÷ 12 rotaciones = 30.4
                          días promedio.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* <!-- DIVIDER --> */}
                  <div class="divider"></div>

                  {/* <!-- FOOTER --> */}
                  <div class="footer-content">
                    {/* <!-- RELACIÓN --> */}
                    <div>
                      <h3>Relación entre métricas</h3>
                      <div class="relacion-items">
                        <div class="relacion-item">
                          <div class="relacion-label">Mayor rotación</div>
                          <div class="relacion-value">Cobranza rápida</div>
                        </div>
                        <div class="relacion-arrow">→</div>
                        <div class="relacion-item">
                          <div class="relacion-label">Menor DPP</div>
                          <div class="relacion-value">Menos días</div>
                        </div>
                      </div>
                    </div>

                    {/* <!-- GUÍA --> */}
                    <div>
                      <h3>¿Por qué importa?</h3>
                      <ul class="guia-list">
                        <li>
                          <strong>Flujo de caja:</strong> Menos días = dinero
                          más rápido en caja.
                        </li>
                        <li>
                          <strong>Eficiencia:</strong> Indica qué tan bien se
                          gestiona la cobranza.
                        </li>
                        <li>
                          <strong>Comparación:</strong> Útil para comparar
                          período con períodos anteriores.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* <button className="excel"
                        onClick={() => onGeneraExcel()}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button> */}
        </div>
      </div>

      <div className="dash-filtro-usados-container">
        <div className="dash-filtro-usados-sucursal">
          <div className="dash-filtro-usado-titulo">Sucursal:</div>
          <div className="dash-filtro-usado-parametros">
            {boxstate.filtro?.length > 0
              ? boxstate.filtro
                  .map((f) =>
                    capitalizeWords(f.descripcion || f.nombre || f.sucursal),
                  )
                  .join(", ")
              : "Todos"}
          </div>
        </div>
      </div>
      {/* <div className="rcxc-miles">(Cifras expresadas en miles de pesos)</div> */}
      {inventario && inventario.length > 0 && (
        <div className="inventario-rotacion-main-container">
          <div className="rotacion-cxc-tabla-container scroll">
            <table cellPadding={0} cellSpacing={0}>
              <colgroup>
                <col className="col-linea" />
                <col className="col-data" />
                <col className="col-data" />
                <col className="col-data" />
                {optima && <col className="col-data" />}
                {optima && <col className="col-data" />}
                <col className="col-data" />
                {!optima && <col className="col-data" />}
                {!optima && <col className="col-data" />}
                <col className="col-data" />
                <col className="col-data" />
              </colgroup>
              <thead>
                <tr>
                  <th>Linea</th>
                  <th>
                    <div>Facturacion de Credito</div>
                  </th>
                  <th>
                    <div>Cartera Inicial</div>
                  </th>
                  <th>
                    <div>Cartera Final</div>
                  </th>
                  {optima && (
                    <th>
                      <div>Cartera Optima</div>
                    </th>
                  )}
                  {optima && (
                    <th>
                      <div>Diferencia Cartera Optima</div>
                    </th>
                  )}
                  <th>
                    <div>Rotacion</div>
                  </th>
                  {!optima && (
                    <th>
                      <div>Guia</div>
                    </th>
                  )}
                  {!optima && (
                    <th>
                      <div>Rotacion Semestral</div>
                    </th>
                  )}
                  {!optima && (
                    <th>
                      <div>Guia Semestral</div>
                    </th>
                  )}
                  {!optima && (
                    <th>
                      <div>Rotacion Anual</div>
                    </th>
                  )}
                    <th>
                      <div>Guia Anual</div>
                    </th>
                  
                  <th>
                    <div>Periodo Promedio de Cobro</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {inventario.map((item, index) => (
                  <tr key={index}>
                    <td className="celda-vendedor">
                      {capitalizePalabras(item.departamento)}
                    </td>
                    <td
                      onClick={() =>
                        onDetalle("C", item.iddepartamento, item.departamento)
                      }
                      className="ta-right detalle"
                    >
                      {FormatMoney(item.credito, 0)}
                    </td>
                    <td
                      className="ta-right detalle"
                      onClick={() =>
                        onDetalle("I", item.iddepartamento, item.departamento)
                      }
                    >
                      {FormatMoney(item.saldo_inicial, 0)}
                    </td>
                    <td
                      onClick={() =>
                        onDetalle("F", item.iddepartamento, item.departamento)
                      }
                      className="ta-right detalle"
                    >
                      {FormatMoney(item.saldo_final, 0)}
                    </td>
                    {optima && (
                      <td className="ta-right">
                        {FormatMoney(item.cartera_optima, 0)}
                      </td>
                    )}
                    {optima && (
                      <td className="ta-right">
                        {FormatMoney(item.diferencia_cartera_optima, 0)}
                      </td>
                    )}
                    <td className="ta-center">{FormatMoney(item.rcxc, 2)}</td>
                    {!optima && (
                      <td className="ta-center">{item.guia}</td>
                    )}
                    {!optima && (
                      <td className="ta-center">{FormatMoney(item.rcxc_semestral, 2)}</td>
                    )}
                    {!optima && (
                      <td className="ta-center">{item.guia_semestral}</td>
                    )}
                    {!optima && (
                      <td className="ta-center">{FormatMoney(item.rcxc_anual, 2)}</td>
                    )}
                      <td className="ta-center">{item.guia_anual}</td>
                    <td className="ta-center">
                      {item.rcxc === 0 ||
                      item.rcxc === "" ||
                      item.rcxc === null ||
                      item.rcxc === undefined
                        ? "0"
                        : (365 / item.rcxc).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                {totales && (
                  <tr>
                    <td className="celda-vendedor">
                      {capitalizePalabras(totales.departamento)}
                    </td>
                    <td
                      onClick={() => onDetalle("C", 0, "Todos")}
                      className="ta-right detalle"
                    >
                      {FormatMoney(totales.credito, 0)}
                    </td>
                    <td
                      onClick={() => onDetalle("I", 0, "Todos")}
                      className="ta-right detalle"
                    >
                      {FormatMoney(totales.saldo_inicial, 0)}
                    </td>
                    <td
                      onClick={() => onDetalle("F ", 0, "Todos")}
                      className="ta-right detalle"
                    >
                      {FormatMoney(totales.saldo_final, 0)}
                    </td>
                    {optima && (
                      <td className="ta-right">
                        {FormatMoney(totales.cartera_optima, 0)}
                      </td>
                    )}
                    {optima && (
                      <td className="ta-right">
                        {FormatMoney(totales.diferencia_cartera_optima, 0)}
                      </td>
                    )}
                    <td className="ta-center">{totales.rcxc}</td>
                    {!optima && (
                      <td className="ta-center">{totales.guia}</td>
                    )}
                    {!optima && (
                      <td className="ta-center">{FormatMoney(totales.rcxc_semestral, 2)}</td>
                    )}
                    {!optima && (
                      <td className="ta-center">{totales.guia_semestral}</td>
                    )}
                    {!optima && (
                      <td className="ta-center">{FormatMoney(totales.rcxc_anual, 2)}</td>
                    )}
                      <td className="ta-center">{totales.guia_anual}</td>
                    <td className="ta-center">
                      {totales.rcxc === 0
                        ? "0"
                        : (365 / totales.rcxc).toFixed(2)}
                    </td>
                  </tr>
                )}
              </tfoot>
            </table>
          </div>
        </div>
      )}
    </PlantillaScreen>
  );
};
